import { useEffect } from 'react';
import { ensureValidAccessToken } from '../services/ensureSessionCredentials';
import { isAccessTokenExpired, resolveActiveRole, TOKEN_EXPIRY_BUFFER_SECONDS } from '../services/ensureSessionCredentials';

const FOCUS_REFRESH_MIN_MS = 30_000;
let lastFocusRefreshAt = 0;

/**
 * Keeps dashboard sessions fresh while the user is active in the app.
 * Refreshes on mount and on focus, debounced and only when the token is near expiry.
 */
export function useSessionRefresh() {
    useEffect(() => {
        const maybeRefresh = (force = false) => {
            const now = Date.now();
            if (!force && now - lastFocusRefreshAt < FOCUS_REFRESH_MIN_MS) {
                return;
            }

            const role = resolveActiveRole();
            if (!role) {
                return;
            }

            const token = localStorage.getItem('token') || localStorage.getItem('userToken');
            const bufferSeconds = TOKEN_EXPIRY_BUFFER_SECONDS + 300;
            if (!force && token && !isAccessTokenExpired(token, bufferSeconds)) {
                return;
            }

            lastFocusRefreshAt = now;
            ensureValidAccessToken(role);
        };

        maybeRefresh(true);

        const refreshIfVisible = () => {
            if (document.visibilityState === 'visible') {
                maybeRefresh(false);
            }
        };

        window.addEventListener('focus', refreshIfVisible);
        document.addEventListener('visibilitychange', refreshIfVisible);

        return () => {
            window.removeEventListener('focus', refreshIfVisible);
            document.removeEventListener('visibilitychange', refreshIfVisible);
        };
    }, []);
}
